const VideosElectronic = [
    {
      video_id: "JAwyisVxXIg",
      title: "Vox",
      artist: "Cocolores",
    },
    {
      video_id: "UPSvy8IDto0",
      title: "Last Day (David August Revision)",
      artist: "Kollektiv Turmstrasse",
    },
  ];
  
  export default VideosElectronic;
  